module.exports = __webpack_public_path__ + "img/QuotesAnimation2.44d333c1.gif";